$.fn.autoPadding = function ($settings) {
  var $config = {
      source: null,
    },
    $target = $(this);

  if ($settings) jQuery.extend($config, $settings);

  $(this).css({
    paddingTop: $config.source.innerHeight() + 'px',
  });

  var windowWidth = $(window).width();

  $(window).resize(function () {
		if ($(window).width() != windowWidth) {
			windowWidth = $(window).width();
			
			$target.css({
				paddingTop: $config.source.innerHeight() + 'px',
			});
		} 
	});
};



// WEBPACK FOOTER //
// ./scripts/util/autoPadding.js